<template>
    <span :class="`badge bg-${color}`">{{ $slots.default }}</span>
  </template>
  
  <script>
  export default {
    name: "Badge",
    props: {
      color: {
        type: String,
        default: "teal"
      }
    }
  };
  </script>
  
  <style scoped>
  .badge {
    padding: 5px 10px;
    border-radius: 5px;
    color: white;
  }
  .bg-purple { background-color: purple; }
  .bg-blue { background-color: blue; }
  .bg-teal { background-color: teal; }
  .bg-green { background-color: green; }
  </style>


// WEBPACK FOOTER //
// src/components/Widgets/Badge.vue